import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  cityValidator,
  drivingLicenseValidator,
  genericStringValidator,
  nameSurnameValidator,
  peselValidatorRelatedRequired,
  phoneValidator,
  streetHouseNumberValidator,
  streetValidator,
} from "../../../../../utilities/validators";
import { trimmedString } from "../../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.INCIDENT_DRIVER]: yup.object({
    [ComponentId.DRIVER_NAME]:
      trimmedString.onlyIfFieldIsVisible(nameSurnameValidator),
    [ComponentId.DRIVER_SURNAME]:
      trimmedString.onlyIfFieldIsVisible(nameSurnameValidator),
    [ComponentId.DRIVER_PHONE]: phoneValidator("driverphone"),
    [ComponentId.DRIVER_PESEL]:
      peselValidatorRelatedRequired("driverLackOfPesel"),
    [ComponentId.DRIVER_OTHER_ID]: trimmedString.onlyIfFieldIsVisible(
      genericStringValidator
    ),
    [ComponentId.DRIVER_OTHER_ID_NUMBER]: trimmedString.onlyIfFieldIsVisible(
      drivingLicenseValidator
    ),
    [ComponentId.DRIVER_STREET]: yup
      .string()
      .onlyIfFieldIsVisible(streetValidator),
    [ComponentId.DRIVER_STREET_2]: yup
      .string()
      .onlyIfFieldIsVisible(streetHouseNumberValidator),
    [ComponentId.DRIVER_CITY]: yup.string().onlyIfFieldIsVisible(cityValidator),
  }),
};
